import Api from "~/service/Api";

class CustomerPaymentRepository {
  fetch(query) {
    return Api.get("/customer-payments", query);
  }

  pay(customerPaymentId, data) {
    return Api.post(`/customer-payments/${customerPaymentId}/pay`, data);
  }
}

export default CustomerPaymentRepository;
